export default __webpack_public_path__ + "static/media/Magic Damage Boost (4h).479963fa.jpg";